import styled from 'styled-components';

export const Container = styled.div`
  border-radius: 5px;
  width: 100% !important;
  min-height: ${({ maximized }) => (maximized ? 'auto' : '32px')};
  transition: height 0.3s;
  background: #FBFBFB;
  border: 1px solid #EEEEEE;
  margin-bottom: 8px;
  padding: 10px;

  display: flex;
  flex-direction: column;
  justify-content: ${({ maximized }) => (!maximized ? 'center' : 'space-between')};
`;

export const Row = styled.div`
  display: flex;
  width: 100%;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  ${({ active }) => active && 'margin-bottom: 25px'};
`;

export const Text = styled.p`
  font-family: 'Roboto', sans-serif;
  font-style: normal;
  font-weight: 500;
  font-size: 12px;
  color: #565656;
  margin: 0;
  margin-left: 5px;
`;

export const Icon = styled.img`
  width: 16px;
  height: 16px;

  :hover{
    opacity: 0.8;
    cursor: pointer;
  }
`;
